'use strict';
const	ComponentFactory	= require('factories/Component')
		, React 			= require('react')
		, loginstyle 		= require('modules/components/login/login.style')
		, LoginForm			= require('modules/components/login/_form')
		;

module.exports = ComponentFactory.create({
	displayName : 'LoginPopupDesktop',
	methods : {
		onForgot : function(e) {
			e.preventDefault();

			this.context.parent &&
			this.context.parent.onForgot();
		},
		onTermsConditions : function(e) {
			e.preventDefault();

			this.context.popup &&
			this.context.popup.add(PopupTermCondition,{
				overrideLogin : true
			})
		},
		closePopup : function(e) {
			e.preventDefault();

			console.log('Close Clicked');

			this.context.popup &&
			this.context.popup.dismissLast()
		},
		__render_title__ : function(type) {
			switch(type) {
			case 'inspiration' :
				return this.translator.toHTML('login.popup_title_origin_inspiration');
			case 'comment' :
				return this.translator.toHTML('login.popup_title_origin_comment');
			case 'saving' :
				return this.translator.toHTML('login.popup_title_origin_save');
			case 'message' :
				return this.translator.toHTML('login.popup_title_origin_message');
			case 'lead' :
				return this.translator.toHTML('login.popup_title_origin_leads');
			case 'review' :
				return this.translator.toHTML('login.popup_title_origin_review');
			case 'pricelist' :
				return this.translator.toHTML('login.popup_title_origin_askforpricelist');
			case 'notitle' :
				return this.translator.toHTML( 'general.label_welcome_to_bridestory' );
			default :
				return this.translator.toHTML('login.popup_label_title');
			}
		},
		__render_subtitle__ : function(type) {
			switch(type) {
			case 'inspiration' :
			case 'comment' :
			case 'saving' :
			case 'message' :
			case 'lead' :
			case 'review' :
			case 'pricelist' :
				return this.translator.toHTML('login.popup_label_subtitle_2');
			case 'notitle' :
				return this.translator.toHTML( 'general.label_welcome_description' );
			default :
				return this.translator.toHTML('login.popup_label_subtitle_1');
			}
		}
	},
	render : function(){
		return (
			<div className="col col-8 bg-c-background-secondary login-popup-h">
				{(()=>{
					if(this.props.title == 'notitle' )
						return (
							<div className="right popup-close f-b-24">
								<span className="icon-close-filled" onClick={this.closePopup.bind(this)} />
							</div>)
				})()}
				<div className="wrapper-block middle-transform">
					<div className="f-tac row row-no-gutter">
						<div className="col col-9 wrapper">
							{(()=>{
								if(this.props.title != 'notitle' )
									return (
										<div className="pb-15">
											<span className="icons-logo-medium" title="Bridestory"></span>
										</div>)
							})()}
							{/* <h3 className={`${this.props.title == 'notitle' ? 'f-b-22' : 'f-b-14'} f-c-text-secondary`}>{ this.__render_title__(this.props.title) }</h3> */}
							{/* <p className="f-g-13 mb-20 mt-10">{ this.__render_subtitle__(this.props.title) }</p> */}
							<h3 className={`f-p-13 semibold f-c-text-secondary`}>{ this.translator.toHTML('login.popup_label_title') }</h3>
							<p className="f-p-13 mb-20 mt-10">{ this.translator.toHTML('login.popup_label_subtitle_1', {registerurl: `/register`}) }</p>
							<LoginForm />
							<p className="pt-10">
								<a className="f-p-12 f-t-u mt-15" target="_self" href={this.getLink('forgotpassword')}>{ this.translator.toHTML( 'login.login_link_forgot' ) }</a>
							</p>
							<p className="f-p-13 mt-25">
								{ this.translator.toHTML( 'login.create_account_text_bottom' ) }
							</p>
						</div>
					</div>
				</div>
			</div>
		)
	}
});



// WEBPACK FOOTER //
// resources/modules/components/login/popup/index/component.jsx